import { videosURL } from "../../apiEndPoints"
import {
    fetchVideos,
    fetchResourceVideos,
} from "../../state/wellnessVideos/wellnessVideosSlice"
import { logTransaction } from "../appActions"
import { axiosGet } from "../../utilities/axiosRequest"

export function VideoLinks() {
    return function (dispatch, getState) {
        let userProfileid = Object.keys(getState().login.user.userProfile)[0]
        const program = getState().user.program
        let url = videosURL + `/${userProfileid}`
        url += `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghjjkjkjj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(fetchVideos(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    dispatch(fetchVideos([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(fetchVideos([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function resourceLinks(linksSucess, linksFailure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        let url = videosURL + `/${getState().patients.selectedPatient.userId}`
        url += `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(fetchResourceVideos(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                    linksSucess && linksSucess()
                } else {
                    dispatch(fetchResourceVideos([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                    linksFailure && linksFailure()
                }
            })
            .catch(err => {
                dispatch(fetchResourceVideos([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
                linksFailure && linksFailure()
            })
    }
}
